import React from 'react';
import BlogDetailContainer from '../../Componant/Blog/BlogDetail';

const BlogDetail = () => {
  return (
    <div className='page-body'>
      <BlogDetailContainer />
    </div>
  );
};

export default BlogDetail;
